import { createVanIconComponent } from "./van"

const Warning = createVanIconComponent("warning")
export default Warning
